import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    border: 'solid 1px rgba(151, 151, 151, 0.12)',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
}));

const ListCard = ({ children, className = {} }) => {
  const classes = useStyles();

  return <Card className={classnames(classes.root, className)}>{children}</Card>;
};

ListCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ListCard;
